import * as React from 'react';
import {Switch, Route} from 'react-router';
import {Router as BrowserRouter} from 'react-router-dom';
import {History} from 'history';

import {AppRoute} from '../../../components/Router/routes';
import {HistoryContext} from '../../contexts/HistoryContext';
import {ROUTES} from '../../../components/Router/consts';

interface Props {
    routes: AppRoute[];
    history: History;
}

export const Router: React.FC<Props> = (props) => {
    const {routes, history} = props;
    return (
        <HistoryContext.Provider value={history}>
            <BrowserRouter history={history}>
                <Switch>{routes.map(renderRoute)}</Switch>
            </BrowserRouter>
        </HistoryContext.Provider>
    );
};

const renderNestedRoute = (Component, children) => (props) => {
    return <Component {...props}>{children.map(renderRoute)}</Component>;
};

export const renderRoute = ({children, Component, exact, path}: AppRoute) => {
    const routePath = path === ROUTES.HOME ? [path, '/index.html'] : path;

    if (!children) {
        return <Route key={path} component={Component} exact={exact} path={routePath} />;
    }

    return <Route key={path} exact={exact} path={routePath} render={renderNestedRoute(Component, children)} />;
};
